<template>
	<sequential-entrance fromLeft>
	<div v-if="this.data.length>0" class="card cardptpr mb-4" :onclick="this.url ? 'window.open(\'' + this.url + '\')' : ''">
		<div class="card-header cardptpr p-3 pb-0 pt-0" v-if="this.title">
			<H6 :class="warning ? 'text-warning' : ''">{{this.title}}</H6>
		</div>
		<div class="card-body p-3">
			<ul class="list-group">
				<li class="list-group-item border-0 d-flex justify-content-between ps-0 pe-0 mb-0 border-radius-lg">
					<div class="col-md-4 text-left">
						<span class="d-flex flex-row justify-content-start text-sm"><b>NAME</b></span>
					</div>
					<div class="col-md-2 text-right"> 
						<span class="d-flex flex-row justify-content-end text-sm"><b>AMOUNT</b></span>
					</div>
					<div class="col-md-2 text-center"> 
						<span class="d-flex flex-row justify-content-center text-sm"><b>AGING (DAYS)</b></span>
					</div>
					<div class="col-md-4 text-left limited-text"> 
						<span class="d-flex flex-row text-sm"><b>FUNGSI/SAM</b></span>
					</div>

				</li>

				<li class="list-group-item border-0 d-flex justify-content-between ps-0 pe-0 mb-0 border-radius-lg" style="cursor: pointer;"
						:onclick="'window.open(\'' + '/finance/report-group?tab=10&vendor=' + item['Account'] + '\')'"
						v-for="(item, index) in this.data" :key="index">
					<div class="col-md-4 text-left">
						<span class="d-flex flex-row justify-content-start text-sm">{{prefix}} {{item[itemcol]}}</span>
					</div>
					<div class="col-md-2 text-right" v-if="valuecol"> 
						<span class="d-flex flex-row justify-content-end text-sm">{{curr}} {{(div ? item[valuecol] / div : item[valuecol]) * 1 | formatNum}} {{unit}}</span>
					</div>

					<div class="col-md-2 text-center"> 
						<span class="d-flex flex-row justify-content-center text-sm"> {{ item['AgingDays']}}</span>
					</div>

					<div class="col-md-4 text-left limited-text"> 
						<span class="d-flex flex-row text-sm"> {{ item['FungsiName'] }}</span>
					</div>

				</li>
			</ul>
		</div>
	</div>
	</sequential-entrance>
</template>

<script>
export default{
	props:["data", "title", "itemcol", "valuecol", "textvaluecol", "warning", "url", "prefix", "curr", "unit", "div"],
	components:{
	},
    mounted(){
    },
    methods:{
		truncateText(str) {
			if (str && typeof str === 'string')
				return str.substring(0, 50);
		},
	}
}

</script>

<style scoped>
.limited-text {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
}

.hover-text {
  display: none;
}

.limited-text:hover .hover-text {
  display: inline;
}
</style>